/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_Q5Inputs */

const es_marketplace_seo_spain_faq_q5 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo reservo en Zarpar?`)
};

const gl_marketplace_seo_spain_faq_q5 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como reservo en Zarpar?`)
};

const en_marketplace_seo_spain_faq_q5 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I book on Zarpar?`)
};

/**
* | output |
* | --- |
* | "How do I book on Zarpar?" |
*
* @param {Marketplace_Seo_Spain_Faq_Q5Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_q5 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_Q5Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_Q5Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_q5(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_q5(inputs)
	return es_marketplace_seo_spain_faq_q5(inputs)
});